module.exports = __webpack_public_path__ + "static/media/air-purifier.0d8f3dc6.png";